// React for Website

import React from "react";
//outsource
import { Col, Select, Form } from "antd";

//components

const VoucherStatus = () => {
  // -------------------------- VAR --------------------------
  const options = [
    {
      label: "Active",
      value: true,
    },
    {
      label: "Inactive",
      value: false,
    },
  ];
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item initialValue={options[0].value} name="active" label="Status">
      <Select showArrow placeholder="Please select status" options={options} />
    </Form.Item>
  );
};

export default VoucherStatus;
